import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useNumbersLayerContext } from 'pages/settings/pages/numbers/context/numbersLayerContext'

export const ImportTwilioNumbersLayout = () => {
  const { redirectToRoot } = useNumbersLayerContext()
  return (
    <StepsCommonLayout
      title='Import from Twilio'
      progressTitle=''
      settingsStep={1}
      totalSteps={1}
      decreaseStep={() => {}}
      closeSetting={redirectToRoot}
    />
  )
}
